import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotificationService } from '@upe/ngx-notification';
import { Observable } from 'rxjs/Observable';
import { HttpService } from './http.service';

export interface IContainer {
  name: string;
}

export interface IFileUpload {
  name: string;
  file: File;
}

@Injectable()
export class FileService extends HttpService {

  public constructor(
    http: HttpClient,
    notification: NotificationService,
    path: string,
  ) {
    super(http, notification, `/api${path}`);
  }

  public listContainers(): Observable<any[]> {
    return this._get('').map((response) => response ? response : []);
  }

  public getContainerInformation(containerName: string): Observable<any | null> {
    return this._get(`/${containerName}`);
  }

  public createContainer(containerName: string): Observable<any | null> {
    return this._post(``, { name: containerName });
  }

  public listFilesInContainer(containerName: string): Observable<any[]> {
    return this._get(`/${containerName}/files`).map((response) => response ? response : []);
  }

  public getFileInformation(containerName: string, fileName: string): Observable<any | null> {
    return this._get(`/${containerName}/files/${fileName}`);
  }

  public deleteFile(containerName: string, fileName: string): Observable<any | null> {
    return this._delete(`/${containerName}/files/${fileName}`);
  }

  public uploadFile(containerName: string, file: File, fileName: string): Observable<any | null> {
    const fd = new FormData();
    fd.append('file', file);

    return this._post(`/${containerName}/upload?filename=${fileName}`, fd);
  }

  public downloadFile(containerName: string, fileName: string): Observable<any | null> {
    return this._get(`/${containerName}/download/${fileName}`);
  }

  public getDownloadUrl(containerName: string, fileName: string): string {
    return `${this.getBackendBaseUrl()}${this._path}/${containerName}/download/${fileName}`;
  }

}
